import { useEffect } from 'react'
import QuestionKey from '../Questions/question-key'
import { fireReactGAEvent } from '../components/Questions/utils'
import { AppFormEventParams } from '../services/events-service'
import { useAppFormEventsService } from './useAppFormEventsService'

type UseQuestionVisibilityTrackingOptions = {
  eventsServiceUrl?: string
  appFormEventParams?: AppFormEventParams
}

export const useQuestionVisibilityTracking = (questionKey: QuestionKey, options?: UseQuestionVisibilityTrackingOptions) => {
  const eventsService = useAppFormEventsService(options?.eventsServiceUrl, options?.appFormEventParams)

  useEffect(() => {
    const label = `qst.${questionKey}`
    fireReactGAEvent({
      category: 'Application Form',
      action: 'Question Visible',
      label,
      nonInteraction: true
    })
    eventsService?.sendEvent('AppFormQuestionVisible', { QuestionLabel: label })
  }, [eventsService, questionKey])
}
